import { Typography, useFetchFile, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { AuthAccountContactTypeChoices, GetJobPositionAssignmentsQuery } from "@graphql/generated";
import { Card, User } from "@heroui/react";
import { formatString } from "@modules/Resume/utils/formatString";
import dayjs from "dayjs";

interface IOrganizationInfoCard {
  organization: NonNullable<
    NonNullable<
      NonNullable<
        NonNullable<
          NonNullable<NonNullable<NonNullable<GetJobPositionAssignmentsQuery>["me"]>["jobPositionAssignments"]>["edges"]
        >["0"]
      >["node"]
    >["jobPosition"]
  >["organization"];
}

const OrganizationInfoCard: React.FC<IOrganizationInfoCard> = ({ organization }) => {
  const { data: logo } = useFetchFile({ urlPath: organization?.logo?.file, userType: UserTypeEnum.USER });
  const website = organization?.contacts?.find((item) => item?.type === AuthAccountContactTypeChoices.WEBSITE)?.value;
  const location =
    organization?.city?.name && organization?.city?.country.name
      ? organization?.city?.name + " , " + organization?.city?.country.name
      : "-";
  const founded = organization?.establishedAt ? dayjs(organization?.establishedAt).format("YYYY/MM/DD") : "-";
  const companySize = formatString(organization?.size?.replace("_", "") || "", " - ");

  return (
    <Card className="p-5 w-full h-fit flex gap-4 items-start overflow-scroll scrollbar-hide">
      <User
        name={organization?.name}
        description={formatString(organization?.businessType || "")}
        avatarProps={{ src: logo, fallback: <></>, radius: "md" }}
      />
      <Typography className="text-sm">{organization?.about}</Typography>
      <RowData label="Website" value={website} />
      <RowData label="Location" value={location} />
      <RowData label="Company Size" value={companySize} />
      <RowData label="Founded" value={founded} />
    </Card>
  );
};

export default OrganizationInfoCard;

const RowData = ({ label, value }: { label: string; value?: string | null }) => {
  return (
    <div className="flex gap-2">
      <Typography variant="muted">{label}:</Typography>

      <Typography className="text-sm">{value || "-"}</Typography>
    </div>
  );
};
